<template>
  <fader>
    <stat-sheet v-if="monster && monster.name" :sheet="monster">
      <template v-slot:title>
        <span>{{ monster.name }}</span>
      </template>
    </stat-sheet>
  </fader>
</template>

<script>
import { mapActions } from 'vuex'
import StatSheet from '@/components/StatSheet'

export default {
  name: `BestiarySheet`,
  components: {
    StatSheet,
  },

  props: {
    name: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      monster: {
        type: Object,
      },
    }
  },

  async created() {
    this.monster = await this.monsterFromAPI(this.name)
  },

  methods: {
    ...mapActions(`bestiary`, [`monsterFromAPI`]),
  },
}
</script>
